import { render, staticRenderFns } from "./md-page.vue?vue&type=template&id=0bcaa1d6&scoped=true"
import script from "./md-page.vue?vue&type=script&lang=js"
export * from "./md-page.vue?vue&type=script&lang=js"
import style0 from "./md-page.vue?vue&type=style&index=0&id=0bcaa1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaa1d6",
  null
  
)

export default component.exports